import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=03a8f4b2&scoped=true&"
import script from "./BaseAvatar.vue?vue&type=script&lang=js&"
export * from "./BaseAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=03a8f4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8f4b2",
  null
  
)

export default component.exports